/* __next_internal_client_entry_do_not_use__ ScrollingNumber,Digit auto */ import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var _ScrollingNumber;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { NumberParser } from "@faire/web--source/common/NumberParser";
import isInteger from "lodash/isInteger";
import { computed } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import styled, { css, keyframes } from "styled-components";
var NumberArray = Array.from(Array(10), function(_, index) {
    return 9 - index;
});
var ScrollingNumber = (_ScrollingNumber = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(ScrollingNumber, _React_Component);
    function ScrollingNumber(props) {
        _class_call_check(this, ScrollingNumber);
        var _this;
        _this = _call_super(this, ScrollingNumber, [
            props
        ]);
        _this.numberParser = new NumberParser();
        _this.renderNumeric = function(currentDigit, index) {
            var _this_props = _this.props, height = _this_props.height, scrollUp = _this_props.scrollUp, omitSeparator = _this_props.omitSeparator;
            var target = _this.getTargetDigitPosition(Number(currentDigit));
            var isIndexZero = !index;
            var isDecimalPointVisited = _this.targetNumberLengthBeforeDecimal < index;
            var shouldSeperate = !((_this.targetNumberLengthBeforeDecimal - index) % 3);
            var shouldAddSeparator = !omitSeparator && !isIndexZero && !isDecimalPointVisited && shouldSeperate && _this.isNumber;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    shouldAddSeparator ? /*#__PURE__*/ _jsx(DigitContainer, {
                        $height: height,
                        children: _this.numberParser.separator
                    }) : null,
                    /*#__PURE__*/ _jsx(DigitContainer, {
                        $height: height,
                        children: /*#__PURE__*/ _jsx(ScrollingContent, {
                            $targetPosition: target,
                            $scrollDurationBasis: _this.props.scrollDurationBasis,
                            $height: height,
                            $scrollUp: scrollUp,
                            children: NumberArray.map(function(value) {
                                return /*#__PURE__*/ _jsx(Digit, {
                                    $height: height,
                                    children: value
                                }, value);
                            })
                        })
                    })
                ]
            });
        };
        _this.renderNonNumeric = function(currentDigit) {
            return /*#__PURE__*/ _jsx(DigitContainer, {
                $height: _this.props.height,
                children: currentDigit === " " ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: "\xa0"
                }) : currentDigit
            });
        };
        _this.getTargetDigitPosition = function(currentDigit) {
            return _this.props.height * (9 - currentDigit);
        };
        makeObservable(_this);
        return _this;
    }
    var _proto = ScrollingNumber.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ _jsx(ScrollingNumberWrapper, {
            className: this.props.className,
            children: new Array(this.targetNumberLength).fill("").map(function(_value, index) {
                var _this_targetNumber_index;
                var currentDigit = (_this_targetNumber_index = _this.targetNumber[index]) !== null && _this_targetNumber_index !== void 0 ? _this_targetNumber_index : "";
                return /*#__PURE__*/ _jsx(React.Fragment, {
                    children: isInteger(parseInt(currentDigit, 10)) ? _this.renderNumeric(currentDigit, index) : _this.renderNonNumeric(currentDigit)
                }, index);
            })
        });
    };
    _create_class(ScrollingNumber, [
        {
            key: "targetNumber",
            get: function get() {
                var _this_props_targetNumber;
                return "".concat((_this_props_targetNumber = this.props.targetNumber) !== null && _this_props_targetNumber !== void 0 ? _this_props_targetNumber : 0);
            }
        },
        {
            key: "targetNumberLengthBeforeDecimal",
            get: function get() {
                var _separatedTargetNumberString_;
                var separatedTargetNumberString = this.targetNumber.split(".");
                var _separatedTargetNumberString__length;
                return (_separatedTargetNumberString__length = (_separatedTargetNumberString_ = separatedTargetNumberString[0]) === null || _separatedTargetNumberString_ === void 0 ? void 0 : _separatedTargetNumberString_.length) !== null && _separatedTargetNumberString__length !== void 0 ? _separatedTargetNumberString__length : 0;
            }
        },
        {
            key: "targetNumberLength",
            get: function get() {
                return this.targetNumber.length;
            }
        },
        {
            key: "isNumber",
            get: function get() {
                return typeof this.props.targetNumber === "number";
            }
        }
    ]);
    return ScrollingNumber;
}(React.Component), _ScrollingNumber.defaultProps = {
    scrollDurationBasis: 0.003,
    height: 24,
    scrollUp: false
}, _ScrollingNumber);
__decorate([
    computed
], ScrollingNumber.prototype, "targetNumber", null);
__decorate([
    computed
], ScrollingNumber.prototype, "targetNumberLengthBeforeDecimal", null);
__decorate([
    computed
], ScrollingNumber.prototype, "targetNumberLength", null);
__decorate([
    computed
], ScrollingNumber.prototype, "isNumber", null);
ScrollingNumber = __decorate([
    observer
], ScrollingNumber);
export { ScrollingNumber };
var DigitContainer = styled.div.withConfig({
    componentId: "sc-4a06e63e-0"
})([
    "display:inline-block;height:",
    "px;overflow:hidden;text-align:center;"
], function(props) {
    return props.$height;
});
var scroll = function(targetPosition, height, scrollUp) {
    return keyframes([
        "from{transform:translateY(",
        ");}to{transform:translateY(-",
        "px);}"
    ], scrollUp ? css([
        "-",
        "px"
    ], height * 9) : "0", targetPosition);
};
var scrollAnimation = function(param) {
    var $targetPosition = param.$targetPosition, $scrollDurationBasis = param.$scrollDurationBasis, $height = param.$height, $scrollUp = param.$scrollUp;
    return css([
        "",
        " ",
        "s ease-out;"
    ], scroll($targetPosition, $height, $scrollUp), ($scrollUp ? $height * 9 - $targetPosition : $targetPosition) * $scrollDurationBasis);
};
var ScrollingContent = styled.div.withConfig({
    componentId: "sc-4a06e63e-1"
})([
    "transform:translateY(-",
    "px);animation:",
    ";"
], function(param) {
    var $targetPosition = param.$targetPosition;
    return $targetPosition;
}, scrollAnimation);
export var Digit = styled.p.withConfig({
    componentId: "sc-4a06e63e-2"
})([
    "height:",
    "px;"
], function(props) {
    return props.$height;
});
var ScrollingNumberWrapper = styled.div.withConfig({
    componentId: "sc-4a06e63e-3"
})([
    "display:inline-flex;"
]);
